import { render, staticRenderFns } from "./Ads_Pending.vue?vue&type=template&id=bc41e6e4&scoped=true&"
import script from "./Ads_Pending.vue?vue&type=script&lang=js&"
export * from "./Ads_Pending.vue?vue&type=script&lang=js&"
import style0 from "./Ads_Pending.vue?vue&type=style&index=0&id=bc41e6e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc41e6e4",
  null
  
)

export default component.exports